import { useHistory } from "react-router-dom";

const QuestionUpdateHeader = () => {

    let history = useHistory();

    return (
        <div className="top_sec signup wf-section">
            <div className="signup_status_group">
                <a href="#" onClick={() => history.goBack()} className="top_back signup w-inline-block">
                    <img src="/assets/images/ic_back_white.svg" loading="lazy" alt="" />
                </a>
            </div>

        </div>
    )
}

export default QuestionUpdateHeader;